// for safety reasons, lets make sure we define a
// preset list of fields when we update or modify a state
export const permittedFields = [
  "name",
  "sms_notif",
  "call_notif",
  "callback_notif",
  "custom_event_notif",
  "owner_change_notif",
  "global_owner_notifications",
  "audio",
  "push_notif_enabled",
  "push_notif_new",
  "push_notif_global",
  "template_hotkeys_enabled",
  "embedded_vars_enabled"
]

export const descriptions = {
  sms_notif: "Send email when they recieve an inbound text message",
  call_notif: "Send email when they recieve an inbound phone call",
  callback_notif: "Send email when they recieve an new voicemail",
  custom_event_notif: "Send email when they recieve an website widget submission",
  owner_change_notif: "Send email when they are assigned to a conversation",
  global_owner_notifications: "Notify them of inbound activity owned by anyone on team",
  audio: "Play a sound when they recieve a new message in the dashboard",
  push_notif_enabled: "Send a push notification to their device for inbound activity for conversations assigned to them",
  push_notif_new: "Send a push notification to their device whenever an inbound activity starts a new conversation",
  push_notif_global: "Send a push notification to their device for any inbound activity owned by anyone on the team",
  template_hotkeys_enabled: "Enable hotkeys for inserting templates",
  embedded_vars_enabled: "Automatically unfurl custom variables within the Avochato Chat Box. Disable to fall back to native browser spellcheck."
}
